import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginState {
    user: string;
    error: string;
    success: boolean;
    isUserLogout: boolean;
    loading: boolean;
}

const initialState: LoginState = {
    user: "",
    error: "",
    success: false,
    isUserLogout: false,
    loading: false
};

const loginSlice = createSlice({
    name: "login",
    initialState, reducers: {
        loginSuccess(state: LoginState, action: PayloadAction<string>) {
            state.user = action.payload;
            state.success = true;
            state.loading = false;
        },
        loginError(state: LoginState, action: PayloadAction<string | any>) {
            state.error = action.payload;
            state.success = false;
            state.loading = false;
        },
        loginStart(state: LoginState) {
            state.loading = true;
            state.error = "";
        },
        logoutSuccess(state: LoginState, action: PayloadAction<boolean>) {
            state.isUserLogout = action.payload;
        },
        resetLogin(state: LoginState) {
            state.error = "";
            state.success = false;
            state.loading = false;
        }
    },
});

export const { loginSuccess, loginError, loginStart, logoutSuccess, resetLogin } = loginSlice.actions;
export default loginSlice.reducer;
